import React from 'react';
import { Facebook, Instagram, Music2 } from 'lucide-react';
import { FACEBOOK_URL, INSTAGRAM_URL, TIKTOK_URL } from '../data/contact';
const links = [{
  label: 'Instagram',
  href: INSTAGRAM_URL,
  Icon: Instagram
}, {
  label: 'Facebook',
  href: FACEBOOK_URL,
  Icon: Facebook
}, {
  label: 'TikTok',
  href: TIKTOK_URL,
  Icon: Music2
}];
interface SocialLinksProps {
  variant?: 'light' | 'dark';
}

/** Instagram · Facebook · TikTok. `light` = for dark backgrounds. */
export function SocialLinks({
  variant = 'light'
}: SocialLinksProps) {
  const isLight = variant === 'light';
  return <ul className="flex gap-4" data-id="element-269" data-mp="14tnh90haq15b">
      {links.map(({
      label,
      href,
      Icon
    }) => <li key={label} data-id="element-270" data-mp="zv2f2vihh7e8">
          <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className={`flex h-10 w-10 items-center justify-center rounded-full border transition-all ${isLight ? 'border-creme/20 text-creme hover:border-caramel hover:bg-caramel hover:text-cacao-900' : 'border-caramel/40 text-cacao-800 hover:border-caramel hover:bg-caramel hover:text-creme'}`} data-id="element-271" data-mp="zvud0czjzh7o">
            <Icon size={17} strokeWidth={1.5} data-id="element-272" data-mp="1osp4aroa86w1" />
          </a>
        </li>)}
    </ul>;
}